export const MENU_TYPE_CLASSIC = 'classic';
export const MENU_TYPE_ROOM = 'room';
